import Vue from 'vue'
import Router from 'vue-router'
import Hello from './../components/Hello'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello
    }
  ]
})



//////////////////
// WEBPACK FOOTER
// ./demo/router/index.js
// module id = 13
// module chunks = 1